@if (productIdentifier != undefined) {
  @switch (viewType) {
    @case (eViewType.GRID) {
      <app-product-list-item-grid [productIdentifier]="productIdentifier">
      </app-product-list-item-grid>
    }
    @case (eViewType.LIST) {
      <app-product-list-item-list [productIdentifier]="productIdentifier">
      </app-product-list-item-list>
    }
  }
}
